//filter/dateFormatWithTime.js
import dayjs from 'dayjs';

function dateFormatWithTime(value = '') {
	return dayjs(value).format('YYYY.MM.DD HH:mm');
}

export default dateFormatWithTime;
